import {
  Create,
  Datagrid,
  DateField,
  DateInput,
  Edit,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from "react-admin";

const filters = [
  <ReferenceInput
    key="job_opening"
    source="job_opening"
    reference="job_openings"
  />,
  <ReferenceInput key="candidate" source="candidate" reference="candidates" />,
  <TextInput key="name" source="name" />,
  <NumberInput key="duration_in_minutes" source="duration_in_minutes" />,
  <DateInput key="created_at" source="created_at" />,
];

export const JobOpeningInterviewList = () => (
  <List filters={filters}>
    <Datagrid>
      <ReferenceField source="job_opening" reference="job_openings" />
      <ReferenceField source="candidate" reference="candidates" />
      <TextField source="name" />
      <NumberField source="duration_in_minutes" />
      <DateField source="created_at" />
    </Datagrid>
  </List>
);

export const JobOpeningInterviewShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <ReferenceField source="job_opening" reference="job_openings" />
      <ReferenceField source="candidate" reference="candidates" />
      <TextField source="name" />
      <NumberField source="duration_in_minutes" />
      <DateField source="created_at" />
    </SimpleShowLayout>
  </Show>
);

export const JobOpeningInterviewCreate = () => (
  <Create>
    <SimpleForm>
      <ReferenceInput source="job_opening" reference="job_openings" />
      <ReferenceInput source="candidate" reference="candidates" />
      <TextInput source="name" />
      <NumberInput source="duration_in_minutes" />
      <DateInput source="created_at" />
    </SimpleForm>
  </Create>
);

export const JobOpeningInterviewEdit = () => (
  <Edit>
    <SimpleForm>
      <ReferenceInput source="job_opening" reference="job_openings" />
      <ReferenceInput source="candidate" reference="candidates" />
      <TextInput source="name" />
      <NumberInput source="duration_in_minutes" />
      <DateInput source="created_at" />
    </SimpleForm>
  </Edit>
);
